"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleSelect = exports.generateDropdowns = exports.generateCheckboxes = void 0;
var _react = require("react");
var _Select = _interopRequireDefault(require("../Select/Select"));
var _Checkbox = _interopRequireDefault(require("../../components/Checkbox/Checkbox"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const handleSelect = (selection, name, methodCall, state, setState) => {
  if (state.name === name) {
    setState({
      [name]: selection
    });
  } else if (state.name !== name) {
    setState({
      ...state,
      [name]: selection
    });
  }
  methodCall(selection, name);
};
exports.handleSelect = handleSelect;
const generateDropdowns = (dropdowns, state, setState, handleDropdownSelect, color) => {
  return dropdowns.map((dropdown, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "ter-filter-hero__single-dropdown-wrapper",
      key: `${dropdown.name}-${index}-dropdown`
    }, /*#__PURE__*/React.createElement("p", {
      className: "ter-filter-hero__dropdown-label",
      style: {
        color: color
      }
    }, dropdown.name), /*#__PURE__*/React.createElement(_Select.default, {
      name: dropdown.name,
      options: dropdown.options,
      handleSelection: e => handleSelect(e, dropdown.name, handleDropdownSelect, state, setState),
      selection: dropdown.selection || state[dropdown.name],
      defaultText: dropdown.defaultText
    }));
  });
};
exports.generateDropdowns = generateDropdowns;
const generateCheckboxes = (checkboxes, state, setState, handleCheckboxChange, color) => {
  return checkboxes.map((checkbox, index) => {
    return /*#__PURE__*/React.createElement(_Checkbox.default, {
      name: checkbox.name,
      label: checkbox.name,
      checked: state.name,
      handleChange: e => handleSelect(e?.target?.checked, e?.target?.name, handleCheckboxChange, state, setState),
      color: color,
      key: `${checkbox.name}-${index}-checkbox`
    });
  });
};
exports.generateCheckboxes = generateCheckboxes;